/**
 * Runtime brand config — ES module wrapper around brand.config.js.
 * To change branding: edit /frontend/brand.config.js (or swap it via scripts/apply-brand).
 */

// eslint-disable-next-line
const brand = require('../../brand.config.js')

export default brand

export const BRAND_NAME        = brand.name
export const BRAND_FULL_NAME   = brand.fullName
export const BRAND_TAGLINE     = brand.tagline
export const BRAND_SHORT_NAME  = brand.shortName
export const BRAND_LOGO        = brand.logo
export const BRAND_FAVICON     = brand.favicon
export const BRAND_COLORS      = brand.colors
export const BRAND_FONT_FAMILY = brand.fontFamily
export const BRAND_SUPPORT_EMAIL = brand.supportEmail
export const BRAND_DEFAULT_LANGUAGE = brand.defaultLanguage
export const BRAND_RTL         = brand.rtl
